var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopIconOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 9.16699H14.6673C7.57966 9.16699 1.83398 14.9127 1.83398 22.0003C1.83398 29.088 7.57966 34.8337 14.6673 34.8337H29.334C36.4216 34.8337 42.1673 29.088 42.1673 22.0003C42.1673 14.9127 36.4216 9.16699 29.334 9.16699Z",
    fill: "#AEAFB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30C18.4183 30 22 26.4183 22 22C22 17.5817 18.4183 14 14 14C9.58172 14 6 17.5817 6 22C6 26.4183 9.58172 30 14 30Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopIconOff);
export default __webpack_public_path__ + "static/media/loop-icon-off.d93e9de49c49b43f1b16352fb84a37f8.svg";
export { ForwardRef as ReactComponent };